/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import {
  BaseIconButton,
  Props as BaseIconButtonProps,
} from '../IconButton/BaseIconButton';

type Props = Omit<BaseIconButtonProps, 'size' | 'isCircle' | 'hasShadow'> & {
  color?: 'icon-primary' | 'icon-secondary';
};

// These map to *-dark data-color attributes that are used for styling
// In styling you'll look for [data-color='icon-primary-dark'], for example
// This mapping makes it simpler for consumers to pass in props
const colorMappings: Record<string, BaseIconButtonProps['color']> = {
  'icon-primary': 'icon-primary-dark',
  'icon-secondary': 'icon-secondary-dark',
};
/**
 * An IconButton for Dark backgrounds.
 */

export function DarkBackgroundIconButton({
  color = 'icon-primary',
  ...props
}: Props) {
  return (
    <BaseIconButton color={colorMappings[color]} size="small" {...props} />
  );
}
